import { Reservation } from '../apis/models/reservations/res/Reservation';
import { ProductOption } from '../apis/models/products/res/ProductOption';
import {
  getProductOptionPrice,
  getProductOptionTotalPrice,
  getProductOptionTotalTax,
} from './utils';

/**
 * 로그인
 */
export const sendLoginEvent = () => {
  // @ts-ignore
  if (window.dataLayer) {
    // @ts-ignore
    window.dataLayer.push({
      event: 'login',
      method: 'SMS인증',
    });
  }
};

/**
 * 장바구니 등록
 */
export const sendAddToCartEvent = (productOptions: ProductOption[]) => {
  // @ts-ignore
  if (window.dataLayer) {
    // @ts-ignore
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'KRW',
        value: getProductOptionTotalPrice(productOptions),
        items: mapProductOptionsToGAItems(productOptions),
      },
    });
  }
};

/**
 * 장바구니 제거
 */
export const sendRemoveFromCartEvent = (productOptions: ProductOption[]) => {
  // @ts-ignore
  if (window.dataLayer) {
    // @ts-ignore
    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: 'KRW',
        value: getProductOptionTotalPrice(productOptions),
        items: mapProductOptionsToGAItems(productOptions),
      },
    });
  }
};

/**
 * 예약 완료
 */
export const sendPurchaseEvent = (
  reservation: Reservation,
  productOptions: ProductOption[],
) => {
  // @ts-ignore
  if (window.dataLayer) {
    const { id } = reservation;
    // @ts-ignore
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        transaction_id: id,
        currency: 'KRW',
        value: getProductOptionTotalPrice(productOptions),
        tax: getProductOptionTotalTax(productOptions),
        items:
          productOptions.length > 0
            ? mapProductOptionsToGAItems(productOptions)
            : [
                {
                  item_id: `방문상담`,
                  item_name: '방문상담',
                  index: 0,
                  price: 0,
                  item_category: '방문상담',
                  item_category2: '방문상담',
                  item_category3: '방문상담',
                },
              ],
      },
    });
  }
};

const mapProductOptionsToGAItems = (
  productOptions: ProductOption[],
): {
  // 상품 구분자 {product_option_id}
  item_id: string;
  // 상품명
  item_name: string;
  // 배열 인덱스
  index: number;
  // 상품 옵션 카테고리 구분자
  item_category: 'category' | 'event' | string;
  // 상품 옵션 카테고리 ,로 구분
  item_category2: string;
  // 상품명
  item_category3: string;
  // 가격
  price: number;
}[] => {
  return productOptions.map((productOption, index) => {
    const { productName, id, productOptionName, categoryName, eventName } =
      productOption;
    const price = getProductOptionPrice(productOption);
    return {
      // 상품 구분자 {product_option_id}
      item_id: `${id}`,
      // 상품명
      item_name: productOptionName,
      // 배열 인덱스
      index:
        typeof productOption.displayIndex === 'number'
          ? productOption.displayIndex
          : index,
      // 상품 옵션 카테고리 ,로 구분
      item_category: categoryName ? 'category' : 'event',
      // 상품 옵션 카테고리 ,로 구분
      item_category2: categoryName || eventName || '',
      // 상품명
      item_category3: productName || '',
      // 가격
      price,
    };
  });
};
